import script from "./OrderedListRecurring.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderedListRecurring.vue?vue&type=script&setup=true&lang=js"

import "./OrderedListRecurring.vue?vue&type=style&index=0&id=6a47478f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a47478f"]])

export default __exports__